/**
 * <s-card-gallery> — highlights the dot for the photo currently in view
 * while a shopper swipes through a product card's photos on mobile.
 */
class CardGalleryElement extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-card-gallery-track]');
    this.dots = Array.from(this.querySelectorAll('[data-card-gallery-dot]'));
    if (!this.track || this.dots.length === 0) return;

    this.handleScroll = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const width = (this.track.clientWidth + gap) || 1;
        const index = Math.round(Math.abs(this.track.scrollLeft) / width);
        this.dots.forEach((dot, i) => dot.toggleAttribute('data-active', i === index));
      });
    };

    this.track.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.handleScroll);
    if (this.frame) cancelAnimationFrame(this.frame);
  }
}

if (!customElements.get('s-card-gallery')) {
  customElements.define('s-card-gallery', CardGalleryElement);
}
